import styled from 'styled-components'

const HeaderRootContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f8f8fa;
  padding: 0.5rem;
`

export default HeaderRootContainer
